export default {
  // 可能是通用的
  Backup: '云端同步',
  Deep_thinking: '深度思考',
  Upload_image: '上传圖片',
  Default: '默认',
  // 独有
  toolInput: {
    TT: '語音轉文字',
    think_only: '僅支持DeepSeek R1',
    placeholder: '樣樣精通，有問必答...'
  }
}
